import { useEnhancedQuery } from 'src/modules/common/application';
import { ACTIVITY } from 'src/services/graphql/queries/activity';
import { Activity } from 'src/modules/common/types';

const useActivity = () => {
  const { loading, data, fetchMore } = useEnhancedQuery<{
    activity: Activity[];
  }>(ACTIVITY, {
    variables: {
      take: 5,
    },
  });

  const handleFetchMore = () => {
    fetchMore({
      variables: {
        skip: data?.activity.length || 0,
        take: 5,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          ...prev,
          activity: [...prev.activity, ...fetchMoreResult.activity],
        };
      },
    });
  };

  return {
    loading,
    data: data?.activity || [],
    handleFetchMore,
  };
};

export default useActivity;
